export enum ComponentsTypeApi {
  PriceOverview = 'PriceOverview',
  PriceOverviewPerPerson = 'PriceOverviewPerPerson',
  CouponCode = 'CouponCode',
  ConditionalMessages = 'ConditionalMessagesComponent',
}
